<template>
  <VBlock class="payment-container" :direction="Direction.column">
    <PreOrderPaymentMethod
      v-if="isLoading === false"
      :paymentMethod="paymentMethod"
      :paymentMethodOptions="paymentMethodOptions"
      :onPaymentMethod="openPaymentMethodModal"
      :paymentNotices="paymentNotices"
      :isUnsignChangeSign="isUnsignChangeSign"
      :onClickNativeBack="onClickNativeBack"
    />
    <!-- <PreOrderNotice v-if="isShowPreOrderNotice" :paymentNotices="paymentNotices" /> -->
    <PreOrderPaymentGiftCard
      v-if="isProvideGiftCard && giftCards && giftCards.cards && giftCards.use"
      :giftCards="giftCards && giftCards.cards"
      :onOpenGiftCardModal="openPaymentGiftCardModal"
    />
    <PreOrderPaymentCoupon
      v-if="isProvideCouponDiscount"
      :coupon="coupon"
      :onCoupon="openPaymentCouponModal"
    />
    <PreOrderBaeminPoint
      v-if="isProvideBaeminPoint"
      :disabled="disabledBaeminPoint"
      :maximumUsableBaeminPoint="maximumUsableBaeminPoint"
      :baeminPoint="baeminPoint"
      :onBaeminPoint="openBaeminPointModal"
    />
    <PreOrderCashReceipt
      v-if="paymentMethod.availableCashReceipt || selectedGiftCardsExist"
      :cashReceiptFold="cashReceiptFold"
      :isSigned="isSigned"
      :registration="recentCashReceipt.issue"
      :type="recentCashReceipt.type"
      :typeArr="cashReceiptType"
      :save="recentCashReceipt.save"
      :number="cashReceiptNumber"
      :onChangeRegistration="onChangeRegistration"
      :onChangeSave="onChangeSave"
      :onChangeInput="onChangeInput"
      :onChangeState="onChangeState"
    />
    <PreOrderPayment
      :includeReturnOrExchangeProduct="includeReturnOrExchangeProduct"
      :price="price"
      :cartDiscount="cartDiscount"
      :coupon="coupon"
      :baeminPoint="baeminPoint"
      :totalPaymentPrice="totalPaymentPrice"
      :isProvideBaeminPoint="isProvideBaeminPoint"
      :onPaymentDetail="openPaymentDetailModal"
    />
  </VBlock>
</template>

<script>
import VBlock, {
  Direction,
  Sort
} from '@/presentationals/v2/components/layouts/molecules/VBlock/index'

import PreOrderPaymentMethod from '../../layouts/organisms/PreOrderPaymentMethod/index'
import PreOrderNotice from '../../layouts/organisms/PreOrderNotice/index'
import PreOrderCashReceipt from '@/presentationals/v2/components/layouts/organisms/PreOrderCashReceipt'
import PreOrderPaymentCoupon from '../../layouts/organisms/PreOrderPaymentCoupon/index'
import PreOrderBaeminPoint from '../../layouts/organisms/PreOrderBaeminPoint/index'
import PreOrderPayment from '../../layouts/organisms/PreOrderPayment/index'
import PreOrderPaymentGiftCard from '../../layouts/organisms/PreOrderPaymentGiftCard/index'

import {
  isProvideBaeminPoint,
  isProvideCouponDiscount,
  isProvideGiftCard
} from '../../../../../config/featureProvider'
import { LogEvent, LogGroup, LogScreenName, LogType } from '@/plugins/AppLogManager'

export default {
  name: 'PreOrderPaymentContainer',
  props: {
    isLoading: Boolean,
    isUnsignChangeSign: Boolean,
    onClickNativeBack: Function
  },
  components: {
    VBlock,
    PreOrderPaymentMethod,
    PreOrderNotice,
    PreOrderCashReceipt,
    PreOrderPaymentCoupon,
    PreOrderBaeminPoint,
    PreOrderPayment,
    PreOrderPaymentGiftCard
  },
  data() {
    return {
      Direction,
      Sort,

      cashReceiptFold: false,
      isFirstTime: false
    }
  },
  computed: {
    price() {
      return this.$store.getters['preOrder/price']
    },
    cartDiscount() {
      return this.$store.getters['preOrder/cartDiscount']
    },
    paymentMethod() {
      return this.$store.getters['preOrder/paymentMethod']
    },
    paymentMethodOptions() {
      return this.$store.getters['preOrder/paymentMethodOptions']
    },
    coupon() {
      return this.$store.getters['preOrder/coupon']
    },
    giftCards() {
      return this.$store.getters['preOrder/giftCards']
    },
    selectedGiftCards() {
      return this.$store.getters['preOrder/selectedGiftCards']
    },
    invalidCards() {
      return this.$store.getters['preOrder/invalidGiftCards']
    },
    baeminPoint() {
      return this.$store.getters['preOrder/baeminPoint']
    },
    paymentNotices() {
      return this.$store.getters['preOrder/paymentNotices']
    },
    totalPaymentPrice() {
      return this.$store.getters['preOrder/totalPaymentPrice']
    },
    includeReturnOrExchangeProduct() {
      return this.$store.getters['preOrder/includeReturnOrExchangeProduct']
    },
    products() {
      return this.$store.getters['preOrder/products']
    },
    isProvideCouponDiscount() {
      const { isSign, appVersion, isAndroid } = this.$store.getters

      return isProvideCouponDiscount({
        appVersion,
        isAndroid,
        isSign,
        includeReturnOrExchangeProduct: this.includeReturnOrExchangeProduct
      })
    },
    isProvideBaeminPoint() {
      const { isSign } = this.$store.getters

      return isProvideBaeminPoint({
        isSign,
        includeReturnOrExchangeProduct: this.includeReturnOrExchangeProduct
      })
    },
    isProvideGiftCard() {
      const { isSign } = this.$store.getters

      return isProvideGiftCard({
        isSign,
        includeReturnOrExchangeProduct: this.includeReturnOrExchangeProduct
      })
    },
    isShowPreOrderNotice() {
      const existsPaymentNotices = this.paymentNotices.length > 0
      const existsBaeminPayIn = this.paymentMethodOptions.some(option =>
        ['BAEMINPAY_BANK', 'BAEMINPAY_CARD'].includes(option.codeName)
      )

      return this.isProvideBaeminPoint && existsPaymentNotices && existsBaeminPayIn
    },
    isShowPaymentMethod() {
      const { orderPrice, deliveryFee } = this.price
      const paymentAmount = orderPrice + deliveryFee

      const couponDiscountAmount = this.coupon.selected.reduce((acc, cur) => {
        let amount = cur.amount
        if (cur.type === 'DELIVERY' && cur.amount > deliveryFee) {
          amount = deliveryFee
        }

        if (cur.type === 'BASKET' && cur.amount > orderPrice) {
          amount = orderPrice
        }

        acc += amount
        return acc
      }, 0)
      const baeminPointDiscountAmount = this.baeminPoint.spentAmount

      const discountAmount = couponDiscountAmount + baeminPointDiscountAmount

      return paymentAmount > discountAmount
    },
    disabledBaeminPoint() {
      return this.baeminPoint.availableAmount === 0
    },
    maximumUsableBaeminPoint() {
      const giftCardDiscountAmount = this.$store.getters['preOrder/selectedGiftCards'].reduce(
        (acc, curr) => {
          return acc + curr.spentAmount
        },
        0
      )
      const orderAmount = this.price.orderPrice
      const deliveryAmount = this.price.deliveryFee
      const cartDiscountAmount = this.cartDiscount.amount
      const couponDiscountAmount = this.coupon.selected.reduce((acc, cur) => {
        function getCouponFilteredPrice(filteredProducts) {
          const filteredTotalitems = filteredProducts.reduce(
            (itemAcc, itemCur) => [...itemAcc, ...itemCur.items],
            []
          )
          const totalPrice = filteredTotalitems.reduce(
            (acc, cur) => acc + cur.unitPrice * cur.quantity,
            0
          )
          return totalPrice
        }

        let amount = cur.amount

        if (cur.type === 'DELIVERY' && cur.amount > this.price.deliveryFee) {
          amount = this.price.deliveryFee
        }

        if (cur.type === 'BASKET') {
          if (cur.displayCatalogIds.length === 0 && cur.displayProductIds.length === 0) {
            // catalogId, productId 해당 없을때
            if (cur.amount > orderAmount) {
              amount = orderAmount
            }
          } else if (cur.displayCatalogIds.length === 0) {
            // catalogId가 없고 productId만 해당될때
            const filteredProducts = this.$store.getters['preOrder/products'].filter(product =>
              cur.displayProductIds.includes(product.productId)
            )

            const totalPrice = getCouponFilteredPrice(filteredProducts)
            const saleCouponPrice = totalPrice < cur.amount ? totalPrice : cur.amount
            amount = saleCouponPrice
          } else if (cur.displayProductIds.length === 0) {
            // productId가 없고 catalogId만 해당 될떄
            const filteredProducts = this.$store.getters['preOrder/products'].filter(product =>
              cur.displayCatalogIds.some(id => product.catalogIds.includes(id))
            )

            const totalPrice = getCouponFilteredPrice(filteredProducts)
            const saleCouponPrice = totalPrice < cur.amount ? totalPrice : cur.amount
            amount = saleCouponPrice
          } else {
            // productId, catalogId 모두 해당될때
            const filteredProducts = this.$store.getters['preOrder/products'].filter(
              product =>
                cur.displayCatalogIds.some(id => product.catalogIds.includes(id)) ||
                cur.displayProductIds.includes(product.productId)
            )

            const totalPrice = getCouponFilteredPrice(filteredProducts)
            const saleCouponPrice = totalPrice < cur.amount ? totalPrice : cur.amount
            amount = saleCouponPrice
          }
        }

        acc += amount
        return acc
      }, 0)

      return (
        orderAmount +
        deliveryAmount -
        (cartDiscountAmount + couponDiscountAmount + giftCardDiscountAmount)
      )
    },

    isSigned() {
      return this.$store.getters.isSign
    },
    recentCashReceipt() {
      return this.$store.getters['preOrder/recentCashReceipt']
    },
    cashReceiptType() {
      return this.$store.getters['preOrder/cashReceiptType']
    },
    cashReceiptNumber() {
      return this.$store.getters['preOrder/cashReceiptNumber']
    },
    selectedGiftCardsExist() {
      return this.$store.getters['preOrder/selectedGiftCards'].length > 0
    },
    selectedCoupon() {
      return this.$store.getters['preOrder/coupon'].selected
    }
  },
  methods: {
    onChangeRegistration(value) {
      if (value === true && this.cashReceiptFold === true) {
        this.cashReceiptFold = false
      }

      this.$store.commit('preOrder/setRecentCashReceipt', {
        issue: value
      })
    },

    onChangeSave() {
      this.$store.commit('preOrder/setRecentCashReceipt', {
        save: !this.$store.getters['preOrder/recentCashReceipt'].save
      })
    },

    onChangeInput(e) {
      this.$store.commit('preOrder/setCashReceiptNumber', e.currentTarget.value)
    },

    onChangeState(state) {
      this.$store.commit('preOrder/setRecentCashReceipt', {
        type: state
      })
    },
    applyPaymentMethodLog(paymentMethod) {
      const params = {
        PurchMethodCd: paymentMethod.methodName,
        ShopNo: this.$store.getters['baeminShopNo']
      }

      // M3-1
      this.$appLogManager.post({
        screenName: LogScreenName.MARKET_ORD_PURCH_METHOD,
        type: LogType.CLICK,
        group: LogGroup.APPLY,
        event: LogEvent.PURCH_METHOD,
        params
      })
    },

    changePaymentMethod(paymentMethod) {
      this.$store.commit('preOrder/setPaymentMethod', paymentMethod)
      this.applyPaymentMethodLog(paymentMethod)
    },

    changeCoupon(coupon) {
      const selectedGiftCardsAmount = this.selectedGiftCards.reduce((acc, curr) => {
        return acc + curr.spentAmount
      }, 0)
      const totalPaymentPrice =
        this.selectedCoupon.length > 0
          ? this.totalPaymentPrice + this.selectedCoupon[0].maximumDiscountAmount
          : this.totalPaymentPrice

      // 상품권,배민포인트가 미리 적용되어있을떄 상품권 + 배민포인트 +할인쿠폰 > 주문금액 인 케이스
      if (
        (coupon && coupon.maximumDiscountAmount) > totalPaymentPrice &&
        (this.baeminPoint.spentAmount > 0 || selectedGiftCardsAmount > 0)
      ) {
        //사용한 상품권, 배민포인트 모두 reset
        this.changeSelectedGiftCards([])
        this.changeBaeminPoint({ spentAmount: null, use: false })
        this.$store.commit('preOrder/setCoupon', coupon)
        this.$store.dispatch('modal/open', {
          type: 'Check',
          message: '결제금액이 변동되었습니다. 결제수단을 다시 선택 해 주세요.',
          onOK: async () => {
            this.$store.dispatch('modal/close')
          }
        })
        return
      }

      this.$store.commit('preOrder/setCoupon', coupon)
      if (this.baeminPoint.use) {
        const spentAmount = this.maximumUsableBaeminPoint

        // 현재 지불금액 < 지불해야 하는 금액
        if (this.baeminPoint.spentAmount > spentAmount) {
          this.changeBaeminPoint({ spentAmount })
        }
      }
    },

    changeSelectedGiftCards(giftCards) {
      this.$store.commit('preOrder/setSelectedGiftCards', giftCards)
    },

    changeBaeminPoint(baeminPoint) {
      this.$store.commit('preOrder/setBaeminPoint', baeminPoint)
    },

    setInvalidGiftCards(giftCards) {
      this.$store.commit('preOrder/setInvalidGiftCards', giftCards)
    },

    openPaymentDetailModal() {
      // TODO 확인필요; 화며설계서에서 사라짐??
      // TODO implement
      this.$store.dispatch('modal/open', {
        type: 'PaymentDetail',
        message: '결제 정보',
        params: {},
        onOK: async () => {
          this.$store.dispatch('modal/close')
        },
        onCancel: async () => {}
      })
    },

    openPaymentMethodModalLog() {
      const params = {
        ShopNo: this.$store.getters['baeminShopNo']
      }

      // M3
      this.$appLogManager.post({
        screenName: LogScreenName.MARKET_ORD_PURCH_METHOD,
        type: LogType.VIEW,
        params
      })
    },

    openPaymentMethodModal() {
      // TODO implement
      this.$store.dispatch('preOrder/openPaymentMethod')
      this.openPaymentMethodModalLog()
    },

    openPaymentCouponModalLog() {
      const params = {
        CpnList: this.coupon.options.map(cpn => ({
          CpnSeq: String(cpn.id),
          Status: cpn.available
        })),
        ShopNo: this.$store.getters['baeminShopNo']
      }

      // M9
      this.$appLogManager.post({
        screenName: LogScreenName.ORD_CPN,
        type: LogType.VIEW,
        group: LogGroup.OrdCpn,
        event: LogEvent.CPN,
        params
      })
    },

    clickPaymentCouponModalLog() {
      const params = {
        CpnList: this.coupon.selected.map((cpn, idx) => ({
          CpnSeq: String(cpn.id),
          Position: idx
        })),
        ShopNo: this.$store.getters['baeminShopNo']
      }

      // M9-1
      this.$appLogManager.post({
        screenName: LogScreenName.ORD_CPN,
        type: LogType.CLICK,
        group: LogGroup.OrdCpn,
        event: LogEvent.SELECT,
        params
      })
    },

    openPaymentCouponModal() {
      this.openPaymentCouponModalLog()
      this.$store.dispatch('modal/open', {
        type: 'Coupon',
        message: '쿠폰',
        renderType: 'full-slide-up',
        params: {
          coupon: this.coupon,
          onCoupon: this.changeCoupon,
          products: this.products
        },
        onOK: () => {
          this.clickPaymentCouponModalLog()
          this.$store.dispatch('modal/close')
        },
        onCancel: () => {
          this.$store.dispatch('modal/close')
        }
      })
    },

    openPaymentGiftCardModal() {
      this.$store.dispatch('modal/open', {
        type: 'GiftCard',
        message: '선물함',
        renderType: 'full-slide-up',
        params: {
          giftCards: this.giftCards.cards,
          selectedGiftCards: this.selectedGiftCards,
          invalidCards: this.invalidCards,
          onSelectGiftCards: this.changeSelectedGiftCards,
          onSetInvalidGiftCards: this.setInvalidGiftCards
        },
        onOK: () => {
          this.$store.dispatch('modal/close')
        },
        onCancel: () => {
          this.$store.dispatch('modal/close')
        }
      })
    },

    openBaeminPointModal() {
      const availableInputs = document.querySelectorAll('input:not(.disabled)')

      if (this.baeminPoint.availableAmount <= 0) return

      this.$store.dispatch('modal/open', {
        type: 'BaeminPoint',
        message: '배민포인트',
        renderType: 'full-slide-up',
        params: {
          maximumUsableBaeminPoint: this.maximumUsableBaeminPoint,
          baeminPoint: this.baeminPoint,
          onBaeminPoint: this.changeBaeminPoint
        },
        onOK: async () => {
          this.$store.dispatch('modal/close')
        },
        onCancel: async () => {},
        availableInputs
      })
    }
  },
  watch: {
    recentCashReceipt(data) {
      if (this.isFirstTime === false) {
        this.cashReceiptFold = data.save
        this.isFirstTime = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.payment-container {
  width: 100%;
  height: auto;
  border-bottom: 1px solid $light-gray-5;
}
</style>
